<template>
    <div class="o-dropdown-otg">
        <span 
            v-if="isShowLabel && label"
            class="dropdown-otg-label"
        >
            {{ label }}
        </span>
        <ADropdown
            :value="value"
            :items="items"
            :disabled="disabled"
            :key-field="keyField"
            :name-field="nameField"
            :placeholder="placeholder || $t('ui.select', 'Select')"
            class="dropdown"
            :filterable="filterable"
            :clearable="clearable"
            @onChange="onChange"
            @onClear="onClear"
            @onOpenChange="onOpenChange"
            ref="aDropdown"
        />
    </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";

import ADropdown from '../../atoms/a-dropdown';

export default {
    name: 'ODropdownOtg',
    components: {
        ADropdown
    },
    props: {
        value: {
            type: [String, Number],
            default: ''
        },
        label : {
            type: String,
            default: ''
        },
        items: {
            type: Array,
            default: () => []
        },
        nameField: {
            type: String,
            default: 'name'
        },
        keyField: {
            type: String,
            default: 'id'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        isShowLabel: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ''
        }
    },
    setup(props, { emit, refs }) {
        const localValue = computed({
            get: () => props.value,
            set: value => {
                emit('input', value);
            }
        });

        function onChange(data) {
            localValue.value = data;
        }

        function onClear() {
            emit('onClear')
        }
        
        function onOpenChange() {
            emit('onOpenChange')
        }
        
        function clearSelect() {
            refs.aDropdown.clearSelect()
        }
        return {
            onOpenChange,
            clearSelect,
            localValue,
            onChange,
            onClear,
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />
